import { render, staticRenderFns } from "./TerminplaetzeDetail.vue?vue&type=template&id=ca514bbe"
import script from "./TerminplaetzeDetail.vue?vue&type=script&lang=ts"
export * from "./TerminplaetzeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_03226246ddea4f5c1fed9b2f163fa79a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports